(() => {
  const BADGE_SELECTOR = '.product-badges[data-context="product"]';
  const VARIANT_DATA_SELECTOR = 'script[data-product-badge-variants]';

  function parseVariantPayload(script) {
    if (!script) return null;

    try {
      return JSON.parse(script.textContent || "{}");
    } catch (error) {
      return null;
    }
  }

  function findProductScope(source) {
    if (!source || !source.closest) return document;
    return source.closest(".shopify-section") || source.closest("product-info") || source.closest("main") || document;
  }

  function findVariant(payload, variantId) {
    const wantedId = Number(variantId || 0);
    if (!payload || !Array.isArray(payload.variants) || !wantedId) return null;

    return payload.variants.find((variant) => Number(variant.id || 0) === wantedId) || null;
  }

  function currentVariantId(source, eventVariant) {
    const directId = Number((eventVariant && eventVariant.id) || 0);
    if (directId) return directId;

    const form = source && source.closest ? source.closest('form[action*="/cart/add"]') : null;
    const idInput = form ? form.querySelector('[name="id"]') : null;
    return Number((idInput && idInput.value) || 0);
  }

  function discountPercent(variant) {
    const price = Number((variant && variant.price) || 0);
    const compareAt = Number((variant && variant.compare_at_price) || 0);

    if (!compareAt || compareAt <= price) return 0;
    return Math.round(((compareAt - price) * 100) / compareAt);
  }

  function updateVisibleLimit(list) {
    if (!list) return;

    const maxVisible = Math.max(1, Number(list.dataset.maxVisible || 0) || 1);
    const badges = Array.from(list.querySelectorAll(".product-badge"));
    let shown = 0;

    badges
      .sort((a, b) => Number(a.dataset.badgePriority || 99) - Number(b.dataset.badgePriority || 99))
      .forEach((badge) => {
        if (badge.dataset.productBadgeInactive === "true") {
          badge.hidden = true;
          return;
        }

        shown += 1;
        badge.hidden = shown > maxVisible;
      });
  }

  function updateBadgeList(list, variant, payload) {
    if (!list || !variant) return;

    const saleBadge = list.querySelector("[data-product-badge-sale]");
    if (!saleBadge) return;

    const discount = discountPercent(variant);
    if (discount > 0) {
      const template = saleBadge.dataset.saleTemplate || (payload && payload.saleTemplate) || "Save __DISCOUNT__%";
      saleBadge.textContent = template.replace("__DISCOUNT__", String(discount));
      saleBadge.dataset.productBadgeInactive = "false";
    } else {
      saleBadge.textContent = "";
      saleBadge.dataset.productBadgeInactive = "true";
    }

    updateVisibleLimit(list);
  }

  function updateFromSource(source, eventVariant) {
    const scope = findProductScope(source);
    const payload = parseVariantPayload(scope.querySelector(VARIANT_DATA_SELECTOR));
    const variant = findVariant(payload, currentVariantId(source, eventVariant));

    if (!variant) return;

    scope.querySelectorAll(BADGE_SELECTOR).forEach((list) => updateBadgeList(list, variant, payload));
  }

  document.addEventListener("variant:change", (event) => {
    updateFromSource(event.target, event.detail && event.detail.variant);
  });

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(BADGE_SELECTOR).forEach((list) => {
      const scope = findProductScope(list);
      const payload = parseVariantPayload(scope.querySelector(VARIANT_DATA_SELECTOR));
      const variantId = scope.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
      const variant = findVariant(payload, variantId);

      if (variant) updateBadgeList(list, variant, payload);
    });
  });
})();

(() => {
  const PATCH_FLAG = "data-sks-newsletter-patch";
  const STORAGE_KEYS = {
    shown: "nlp:shown",
    dismissed: "nlp:dismissed",
    dismissedPermanent: "nlp:dismissed-permanent",
    collapsed: "nlp:collapsed",
    subscribed: "theme:popup-filled",
    pageViews: "nlp:pageviews"
  };

  function injectStyles() {
    if (document.getElementById("sks-newsletter-popup-patch-style")) return;

    const style = document.createElement("style");
    style.id = "sks-newsletter-popup-patch-style";
    style.textContent = `
      newsletter-popup.newsletter-popup {
        transition: padding .25s ease, width .25s ease, transform .4s cubic-bezier(.645, .045, .355, 1), opacity .4s cubic-bezier(.645, .045, .355, 1);
      }

      .newsletter-popup__toggle-button {
        position: absolute !important;
        inset-block-start: 1.25rem;
        inset-inline-end: 3.75rem;
        z-index: 1;
        display: grid;
        place-items: center;
        width: 1.75rem;
        height: 1.75rem;
        color: currentColor;
        opacity: .72;
        transition: opacity .2s ease;
      }

      .newsletter-popup__toggle-button:hover,
      .newsletter-popup__toggle-button:focus-visible {
        opacity: 1;
      }

      .newsletter-popup__expand-icon {
        display: none;
      }

      .newsletter-popup--collapsed {
        padding-block: 1.25rem;
        padding-inline-start: 1.5rem;
        padding-inline-end: 5.75rem;
        width: min(23.75rem, calc(100vw - 2rem));
      }

      .newsletter-popup--collapsed .newsletter-popup__inner,
      .newsletter-popup--collapsed .newsletter-popup__intro {
        gap: 0;
      }

      .newsletter-popup--collapsed .newsletter-popup__intro {
        text-align: start;
      }

      .newsletter-popup--collapsed .newsletter-popup__title {
        font-size: var(--text-h5);
        line-height: 1.35;
      }

      .newsletter-popup--collapsed [data-newsletter-popup-collapsible],
      .newsletter-popup--collapsed .newsletter-popup__collapse-icon {
        display: none !important;
      }

      .newsletter-popup--collapsed .newsletter-popup__expand-icon {
        display: block;
      }

      @media screen and (max-width: 699px) {
        .newsletter-popup__toggle-button {
          inset-inline-end: 3.5rem;
        }

        .newsletter-popup--collapsed {
          padding-inline-start: 1.25rem;
          padding-inline-end: 5.25rem;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function svgIcon(path) {
    return `<svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon" viewBox="0 0 16 16"><path d="${path}" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  }

  function preparePopupMarkup(popup) {
    let toggleButton = popup.querySelector("[data-newsletter-popup-toggle]");
    const closeButton = popup.querySelector(".pop-in__close-button");

    const inner = popup.querySelector(".newsletter-popup__inner") || closeButton?.closest("dialog-close-button")?.nextElementSibling;
    const intro = popup.querySelector(".newsletter-popup__intro") || inner?.firstElementChild;
    const title = popup.querySelector(".newsletter-popup__title") || intro?.querySelector(".h4");
    const body = popup.querySelector(".newsletter-popup__body") || intro?.querySelector(".prose");
    const form = popup.querySelector(".newsletter-popup__form") || inner?.querySelector("form")?.parentElement || inner?.querySelector("form");

    inner?.classList.add("newsletter-popup__inner");
    intro?.classList.add("newsletter-popup__intro");
    title?.classList.add("newsletter-popup__title");
    body?.classList.add("newsletter-popup__body");
    form?.classList.add("newsletter-popup__form");
    body?.setAttribute("data-newsletter-popup-collapsible", "");
    form?.setAttribute("data-newsletter-popup-collapsible", "");

    if (!toggleButton && closeButton) {
      toggleButton = document.createElement("button");
      toggleButton.type = "button";
      toggleButton.className = "newsletter-popup__toggle-button tap-area";
      toggleButton.setAttribute("aria-label", "Riduci popup newsletter");
      toggleButton.setAttribute("aria-expanded", "true");
      toggleButton.setAttribute("data-newsletter-popup-toggle", "");
      toggleButton.innerHTML = `
        <span class="newsletter-popup__collapse-icon">${svgIcon("M3 8h10")}</span>
        <span class="newsletter-popup__expand-icon">${svgIcon("m4 10 4-4 4 4")}</span>
      `;
      closeButton.closest("dialog-close-button")?.before(toggleButton);
    }

    return {
      toggleButton,
      closeButton,
      collapsibleElements: popup.querySelectorAll("[data-newsletter-popup-collapsible]")
    };
  }

  function setCollapsedState(popup, controls, isCollapsed) {
    popup.classList.toggle("newsletter-popup--collapsed", isCollapsed);

    if (controls.toggleButton) {
      controls.toggleButton.setAttribute("aria-expanded", isCollapsed ? "false" : "true");
      controls.toggleButton.setAttribute("aria-label", isCollapsed ? "Apri popup newsletter" : "Riduci popup newsletter");
    }

    controls.collapsibleElements.forEach((element) => {
      if (isCollapsed) {
        element.setAttribute("hidden", "");
      } else {
        element.removeAttribute("hidden");
      }
    });

    if (isCollapsed) {
      sessionStorage.setItem(STORAGE_KEYS.collapsed, "1");
    } else {
      sessionStorage.removeItem(STORAGE_KEYS.collapsed);
    }
  }

  function shouldSkipPopup(popup) {
    if (localStorage.getItem(STORAGE_KEYS.subscribed) === "true") return true;
    if (sessionStorage.getItem(STORAGE_KEYS.dismissed) === "1") return true;
    if (popup.hasAttribute("only-once") && localStorage.getItem(STORAGE_KEYS.dismissedPermanent) === "1") return true;

    const path = window.location.pathname.toLowerCase();
    const excludedPaths = ["/cart", "/checkout", "/account", "/orders", "/challenge"];
    if (excludedPaths.some((excludedPath) => path.indexOf(excludedPath) === 0)) return true;
    return path.indexOf("/thank_you") >= 0 || path.indexOf("/order") >= 0;
  }

  function getNewsletterPageViewCount() {
    let currentCount = parseInt(sessionStorage.getItem(STORAGE_KEYS.pageViews) || "0", 10);

    if (!Number.isFinite(currentCount) || currentCount < 0) {
      currentCount = 0;
    }

    if (!window.__sksNewsletterPageViewCounted) {
      currentCount += 1;
      window.__sksNewsletterPageViewCounted = true;
      sessionStorage.setItem(STORAGE_KEYS.pageViews, String(currentCount));
    }

    return currentCount;
  }

  function showPopup(popup, controls, options = {}) {
    if (!options.restore && popup.hasAttribute("data-sks-newsletter-shown")) return;

    const cartDrawer = document.querySelector("cart-drawer[open], .cart-drawer[open]");
    const blockingModal = document.querySelector(".modal[open], dialog[open]");
    if (cartDrawer || blockingModal) {
      setTimeout(() => showPopup(popup, controls, options), 5000);
      return;
    }

    popup.setAttribute("data-nlp-ready", "");
    popup.setAttribute("data-sks-newsletter-shown", "1");
    setCollapsedState(popup, controls, options.collapsed === true);

    const openWhenReady = () => {
      if (typeof popup.show !== "function") {
        setTimeout(openWhenReady, 150);
        return;
      }

      popup.show();
      sessionStorage.setItem(STORAGE_KEYS.shown, "1");
    };

    if (window.customElements && typeof window.customElements.whenDefined === "function") {
      window.customElements.whenDefined("newsletter-popup").then(openWhenReady);
    } else {
      openWhenReady();
    }
  }

  function initNewsletterPopupPatch() {
    const popup = document.querySelector("newsletter-popup");
    if (!popup || popup.hasAttribute(PATCH_FLAG) || popup.hasAttribute("data-sks-newsletter-controller")) return;

    popup.setAttribute(PATCH_FLAG, "1");
    injectStyles();

    const controls = preparePopupMarkup(popup);

    controls.toggleButton?.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      setCollapsedState(popup, controls, !popup.classList.contains("newsletter-popup--collapsed"));
    });

    controls.closeButton?.addEventListener("click", () => {
      sessionStorage.setItem(STORAGE_KEYS.dismissed, "1");
      sessionStorage.setItem(STORAGE_KEYS.shown, "1");
      sessionStorage.removeItem(STORAGE_KEYS.collapsed);

      if (popup.hasAttribute("only-once")) {
        localStorage.setItem(STORAGE_KEYS.dismissedPermanent, "1");
      }
    });

    if (shouldSkipPopup(popup)) return;

    if (getNewsletterPageViewCount() < 2) return;

    if (sessionStorage.getItem(STORAGE_KEYS.shown) === "1" && sessionStorage.getItem(STORAGE_KEYS.collapsed) === "1") {
      showPopup(popup, controls, { restore: true, collapsed: true });
      return;
    }

    setTimeout(() => showPopup(popup, controls), 5000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initNewsletterPopupPatch);
  } else {
    initNewsletterPopupPatch();
  }
})();
